module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/ico_arrow_top-b76b26bf922f0e0867c0338a704df5ac.svg";